import Singleton from '../Singleton';
import InfoError from '../_shared/models/InfoError';
import ErrorService from './ErrorService';

export default class AccessIBeService extends Singleton<AccessIBeService> {
  static init = () => {
    try {
      if (process.env.REACT_APP_ACCESSIBE_ENABLED) {
        const script = document.createElement('script');
        const h = document.querySelector('head') || document.body;
        script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
        script.async = true;

        script.onload = () => {
          // eslint-disable-next-line no-undef
          acsbJS?.init({
            statementLink: '',
            footerHtml: '',
            hideMobile: false,
            hideTrigger: false,
            disableBgProcess: false,
            language: 'en',
            position: 'right',
            leadColor: '#146FF8',
            triggerColor: '#146FF8',
            triggerRadius: '50%',
            triggerPositionX: 'right',
            triggerPositionY: 'bottom',
            triggerIcon: 'people',
            triggerSize: 'bottom',
            triggerOffsetX: 20,
            triggerOffsetY: 20,
            mobile: {
              triggerSize: 'small',
              triggerPositionX: 'right',
              triggerPositionY: 'bottom',
              triggerOffsetX: 10,
              triggerOffsetY: 10,
              triggerRadius: '20'
            }
          });
        };
        h.appendChild(script);
      }
    } catch (err) {
      ErrorService.trackError(
        new InfoError(`Error initializing AccessIBe Widget: ${err}`)
      );
    }
  };
}
